import type { LoaderFunctionArgs } from "@remix-run/cloudflare";
import {
  Outlet,
  redirect,
  useMatches,
  useRouteLoaderData,
} from "@remix-run/react";
import { Header } from "~/components/common/Header";
import { supportedLngs } from "~/i18n";
import { cn } from "~/lib/utils";

export async function loader({ params, request, context }: LoaderFunctionArgs) {
  const i18nDisabled = context?.cloudflare?.env?.I18N_DISABLED === "true";

  if (params.locale && i18nDisabled) {
    const url = new URL(request.url);
    const pathWithoutLocale =
      url.pathname.replace(`/${params.locale}`, "") || "/";
    return redirect(pathWithoutLocale + url.search + url.hash);
  }

  if (params.locale && !supportedLngs.includes(params.locale)) {
    throw new Response(null, {
      status: 404,
      statusText: "Not Found",
    });
  }
  return null;
}

export default function LocaleLayout() {
  const matches = useMatches();
  const rootLoaderData = useRouteLoaderData<any>("root");

  const navbarConfig = matches
    .map((match) => (match.handle as any)?.navbar)
    .filter(Boolean)
    .pop();

  return (
    <>
      <Header
        variant={navbarConfig?.variant}
        className={navbarConfig?.className}
        navClassName={navbarConfig?.navClassName}
        bookingDisabled={rootLoaderData?.bookingDisabled}
        shopDisabled={rootLoaderData?.shopDisabled}
      />
      <div
        className={cn({
          "pt-20 lg:pt-24": navbarConfig?.variant !== "transparent",
        })}
      >
        <Outlet />
      </div>
    </>
  );
}
